// import { useMemo } from 'react';
// Refactorizar con useMemo
import { IField } from 'components/shared/form/IField';

export function useField(fields: IField[], fieldName: string): IField | undefined {
  return fields.find((field) => field.name == fieldName);
}

export default useField;
